// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UpdateCredentialsForm_buttons__2Bg71","fieldsList":"UpdateCredentialsForm_fieldsList__p-Cx5"};